import Container from 'app/components/common/Container';

import CloudinaryImage from '../common/CloudinaryImage';

export default function OurStory({ section }) {
  return (
    <Container className="flex flex-col md:flex-row md:py-12 py-6 items-center mt-16 ">
      <div className="md:basis-1/2 space-y-4">
        <h3 className="flex items-center text-[20px] font-[400] text-[#383838]">
          {section?.title}

          <span className="ml-6 font-bold inline-block w-[59px] h-[2px] bg-[#353535]"></span>
        </h3>
        <h1 className=" font-[800] xl:text-[60px] md:text-[32px] text-[26px] title_hd mb-4 leading-tight">
          {section?.h1_black}
        </h1>
        <p className="font-[400] text-[18px] text-[#373737] leading-tight">
          {section?.p}
        </p>
        <div className="grid grid-cols-12 gap-8 mt-3">
          <div className="sm:col-span-6 col-span-12">
            {section?.list[0]?.image?.data?.attributes?.url && (
              <span className="inline-block mb-2">
                <CloudinaryImage
                  backendImgUrl={section?.list[0]?.image?.data?.attributes?.url}
                  alt="arrow-right-white"
                  className=" w-10 h-10"
                  type="icon"
                />
              </span>
            )}
            <h4 className="text-[16px] text-[#000000] font-[600]">
              {section?.list[0]?.h}
            </h4>
            <hr className="my-4 border-t-2" />
            <p className="text-[14px] w-2/3">{section?.list[0]?.p}</p>
          </div>
          <div className="sm:col-span-6 col-span-12">
            {section?.list[1]?.image?.data?.attributes?.url && (
              <span className="inline-block mb-2">
                <CloudinaryImage
                  backendImgUrl={section?.list[1]?.image?.data?.attributes?.url}
                  alt="arrow-right-white"
                  className=" w-10 h-10"
                  type="icon"
                />
              </span>
            )}
            <h4 className="text-[16px] text-[#000000] font-[600]">
              {section?.list[1]?.h}
            </h4>
            <hr className="my-4 border-t-2" />
            <p className="text-[14px] w-2/3">{section?.list[1]?.p}</p>
          </div>
        </div>
      </div>
      <div className="md:basis-1/2 image-container">
        {section?.image?.data?.attributes?.url && (
          <CloudinaryImage
            backendImgUrl={section?.image?.data?.attributes?.url}
            alt={section?.image?.data?.attributes?.alternativeText}
            className={`image !w-full`}
            type="smallimg"
          />
        )}
      </div>
    </Container>
  );
}
